<template>
  <AdvancedMarker v-for="(marker, index) in markers" :key="index" :options="marker.options"
                  :pin-options="marker.pinOptions">
    <InfoWindow v-model="marker.isOpenOnMount" :options="getInfoWindowOptions(marker.pinTitle)">
      <p id="infoWindowTitle"> {{ marker.pinTitle }} </p>
      <p id="infoWindowDescription"> {{ marker.pinDescription }}</p>
    </InfoWindow>
  </AdvancedMarker>
</template>

<script setup>
import {AdvancedMarker, InfoWindow} from 'vue3-google-map';
import {ref, watch} from "vue";
import {useMapCommon} from "@/composables/MapCommon";

// all optional
const props = defineProps({
  origin: {
    type: Object
  },
  destination: {
    type: Object
  }
})

// list of attributes for markers on the map
const markers = ref([]);

const originPinOptions = {background: "green", borderColor: "darkGreen", glyph: 'A', glyphColor: 'black'};
const destinationPinOptions = {background: "red", borderColor: "darkRed", glyph: 'B', glyphColor: 'black'};
const roomPinOptions = {background: "white", borderColor: "gray", glyphColor: "gray", scale: 0.5};

const {stringLatLngToNumberLatLng} = useMapCommon()

// adds a green A marker
watch(() => props.origin,
  (origin) => {
    if (!origin) {
      return;
    }

    addMarker(
      {position: stringLatLngToNumberLatLng(origin.entrance.latLng), title:`Origin: ${origin.locationName}`},
      originPinOptions,
      origin.entrance.name,
      null,
      false
    );
  },
  {immediate: true}
);

// adds a red B marker and optionally a room marker
watch(() => props.destination,
  (destination) => {
    if (!destination) {
      return;
    }

    addMarker(
      {position: stringLatLngToNumberLatLng(destination.entrance.latLng), title:`Destination: ${destination.locationName}`},
      destinationPinOptions,
      destination.entrance.name,
      destination.directions,
      true
    );

    const isDestinationRoom = destination.locationId.length > 3;
    if (isDestinationRoom) {
      addRoomMarker(destination);
    }
  },
  {immediate: true}
);

function addMarker(options, pinOptions, pinTitle, pinDescription, isOpenOnMount) {
  markers.value.push({options, pinOptions, pinTitle, pinDescription, isOpenOnMount});
}

function addRoomMarker(location) {
  addMarker(
    {position: stringLatLngToNumberLatLng(location.latLng), title:location.locationName},
    roomPinOptions,
    location.locationName,
    null,
    false
  );
}

function getInfoWindowOptions(pinTitle) {
  return {disableAutoPan: true, ariaLabel:pinTitle };
}
</script>

<style scoped>
#infoWindowTitle {
  font-weight: bold;
  font-size: 20px;
}

#infoWindowDescription {
  font-size: 16px;
}

</style>
